import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../../utils/Functions'

const ShutterModel = ({ width, height }) => {
    const trimThickness = 0.1;
    const windowThickness = 0.3;
    const alpha = Math.PI / 3
    const wingWidth = width - trimThickness * 2;
    const wingHeight = (windowThickness / 2) / Math.cos((Math.PI / 2 - alpha))
    const wingAreaHeight = (height - trimThickness * 2 - (trimThickness / 4 * 3) * 2) / 2;

    const distance = (wingHeight * Math.cos(alpha))
    const count = useMemo(() => {
        const numberWing = Math.floor(wingAreaHeight / distance);
        if (wingAreaHeight - distance * numberWing >= distance / 4) {
            return numberWing + 1;
        } else {
            return numberWing
        }
    
    }, [height]);


    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2, height / 2);
        model.lineTo(width / 2, height / 2);
        model.lineTo(width / 2, -height / 2);
        model.lineTo(-width / 2, -height / 2);
        model.closePath();

        const hole_upper = new THREE.Path();
        hole_upper.moveTo(-width / 2 + trimThickness, height / 2 - trimThickness);
        hole_upper.lineTo(width / 2 - trimThickness, height / 2 - trimThickness);
        hole_upper.lineTo(width / 2 - trimThickness, trimThickness / 4 * 3);
        hole_upper.lineTo(-width / 2 + trimThickness, trimThickness / 4 * 3);
        hole_upper.closePath();

        const hole_under = new THREE.Path();
        hole_under.moveTo(-width / 2 + trimThickness, -trimThickness / 4 * 3);
        hole_under.lineTo(width / 2 - trimThickness, -trimThickness / 4 * 3);
        hole_under.lineTo(width / 2 - trimThickness, -height / 2 + trimThickness);
        hole_under.lineTo(-width / 2 + trimThickness, -height / 2 + trimThickness);
        hole_under.closePath();

        model.holes.push(hole_upper);
        model.holes.push(hole_under);

        return model;
    }, [width, height])

    const wingModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-wingWidth / 2, 0);
        model.lineTo(-wingWidth / 2, -wingHeight);
        model.lineTo(wingWidth / 2, -wingHeight);
        model.lineTo(wingWidth / 2, 0);
        model.closePath();

        return model
    
    }, [width, height])
    
    return (
        <group>
            <mesh name='trim-model'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial color={'#B0B0B0'} side={THREE.DoubleSide} />
            </mesh>
            {new Array(count).fill("").map((_, indexI) =>
                new Array(2).fill("").map((_, indexJ) =>
                    new Array(2).fill("").map((_, indexZ) =>
                        <mesh name='pattern-wing-model' position={[0, -height / 2 * indexJ + (indexJ === 0 ? trimThickness / 4 * 3 : trimThickness) + distance * indexI + distance, 0.14]} rotation={[Math.pow(-1, indexZ) * alpha, 0, 0]}>
                            <extrudeGeometry args={[wingModel, extrudeSettings(0.03)]} />
                            <meshStandardMaterial color={'#FFFFFF'} side={THREE.DoubleSide} metalness={0.3} />
                        </mesh>
                    )
                )
            )}
        </group>
    )
}

export default ShutterModel